import { render, staticRenderFns } from "./TariffRestrictionNotice.vue?vue&type=template&id=500060d8&scoped=true&"
import script from "./TariffRestrictionNotice.vue?vue&type=script&lang=js&"
export * from "./TariffRestrictionNotice.vue?vue&type=script&lang=js&"
import style0 from "./TariffRestrictionNotice.vue?vue&type=style&index=0&id=500060d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500060d8",
  null
  
)

export default component.exports